import {
  C, checkedInCount, waitingCount, avgWait, noShowRiskCount,
  filledSlots, totalSlots, estRevenue, aiActionsCount,
} from './frontDeskData';

export const FDContextBar = ({ show, onClose }) => {
  if (!show) return null;
  return (
    <div style={{ height: 34, background: '#fafafa', borderBottom: '.5px solid #ebebeb', padding: '0 20px', display: 'flex', alignItems: 'center', flexShrink: 0, fontSize: 11 }} data-testid="fd-context-bar">
      {/* Left — ops stats */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
        <span style={{ display: 'flex', alignItems: 'center', gap: 4 }}><span style={{ width: 6, height: 6, borderRadius: '50%', background: C.green }} /><strong>{checkedInCount}</strong> checked in</span>
        <span style={{ display: 'flex', alignItems: 'center', gap: 4 }}><span style={{ width: 6, height: 6, borderRadius: '50%', background: waitingCount > 0 && avgWait > 15 ? C.amber : C.amber }} /><strong>{waitingCount}</strong> waiting{avgWait > 15 ? ` · >${avgWait}m` : ''}</span>
        <span style={{ display: 'flex', alignItems: 'center', gap: 4 }}><span style={{ width: 6, height: 6, borderRadius: '50%', background: C.red }} /><strong>{noShowRiskCount}</strong> no-show risk</span>
      </div>
      <div style={{ flex: 1 }} />
      {/* Center — financial */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
        <span><strong style={{ color: C.black }}>{filledSlots} slots filled of {totalSlots} today</strong></span>
        <span style={{ color: C.green, fontWeight: 500 }}>Est. revenue: ${estRevenue.toLocaleString()}</span>
      </div>
      <div style={{ flex: 1 }} />
      {/* Right — AI */}
      <span style={{ color: C.green, fontWeight: 500, fontSize: 10 }}>Echo AI: {aiActionsCount} actions handled</span>
      <button onClick={onClose} style={{ marginLeft: 10, fontSize: 12, color: '#ccc', background: 'none', border: 'none', cursor: 'pointer' }} data-testid="fd-close-context">&times;</button>
    </div>
  );
};
